export default "__VITE_ASSET__DQAsF2Ok__"